import { render, staticRenderFns } from "./MerchantStatementsDetail.vue?vue&type=template&id=8d8400de&scoped=true"
import script from "./MerchantStatementsDetail.vue?vue&type=script&lang=js"
export * from "./MerchantStatementsDetail.vue?vue&type=script&lang=js"
import style0 from "./MerchantStatementsDetail.vue?vue&type=style&index=0&id=8d8400de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8400de",
  null
  
)

export default component.exports